import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-screen px-6 bg-gray-200" }
const _hoisted_2 = { class: "w-full max-w-sm p-6 bg-white rounded-md shadow-md" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-gray-700" }, "IOM-Dashboard", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}
const _hoisted_8 = { class: "block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-700" }, "Email", -1)
const _hoisted_10 = { class: "block mt-3 relative" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-700" }, "Password", -1)
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "mt-6" }
const _hoisted_14 = ["disabled"]

import { ref } from "vue";
import { POST_LOGIN } from "@/store/auth.module";
import { useStore } from "vuex";
import IcEyeOpen from "@/assets/svg/ic-eye-open.vue";
import IcEyeClose from "@/assets/svg/ic-eye-close.vue";

// Initialize Vuex store and router

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

// Reactive state for email, password, and error message
const email = ref("");
const password = ref("");
const isLoading = ref(false);
const errorMessage = ref("");
const showPassword = ref(false);

// Function to handle login
async function login() {
  // Reset the error message before validation
  errorMessage.value = "";
  const payload = {
    data:{
      email: email.value,
      password: password.value
    }
  };

  try {
    isLoading.value = true;
    const data = await store.dispatch(POST_LOGIN, payload);

    if (data?.token) {
      // Set the cookie with token
      const expires = new Date();
      expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days from now
      document.cookie = `PSSID=${data.token}; path=/; secure; expires=${expires.toUTCString()}`;
      
      // Redirect to dashboard
      window.location.href = "/dashboard";
    } else {
      // If invalid, show error message
      errorMessage.value = data;
    }
  } catch (error:any) {
    errorMessage.value = error?.message;
  }finally{
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/image/logo.png'),
          alt: "IOM-ITB",
          class: "w-[60px]"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ]),
      _createElementVNode("form", {
        class: "mt-4",
        onSubmit: _withModifiers(login, ["prevent"])
      }, [
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "block w-full mt-1 border border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 p-2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("label", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: showPassword.value ? 'text' : 'password',
            class: "block w-full mt-1 border border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 p-2",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            required: ""
          }, null, 8, _hoisted_12), [
            [_vModelDynamic, password.value]
          ]),
          _createElementVNode("span", {
            class: "absolute inset-y-0 top-[40%] right-0 flex items-center pr-3 cursor-pointer text-black w-[32px]",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
          }, [
            (showPassword.value)
              ? (_openBlock(), _createBlock(IcEyeClose, { key: 0 }))
              : (_openBlock(), _createBlock(IcEyeOpen, { key: 1 }))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "submit",
            class: "w-full px-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500",
            disabled: isLoading.value
          }, _toDisplayString(isLoading.value ? "Loading..." : "Sign in"), 9, _hoisted_14)
        ])
      ], 40, _hoisted_6)
    ])
  ]))
}
}

})